import React, { Component } from 'react'
import "./index.scss";
export default class index extends Component {
    render() {
        return (
            <div className="table-7-4-chart">
                <div id="c1"></div>
                <div className="row">
                    <div className="col-c" id="c2"></div>
                    <div className="col-c" id="c3"></div>
                    <div className="col-c" id="c4"></div>
                    <div className="col-c" id="c5"></div>
                    <div className="col-c" id="c6"></div>
                    <div className="col-c" id="c7"></div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-4/chart/index.js